import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getAccounts,
  getAccount,
  createAccount,
  updateAccount,
  deleteAccount,
  getAccountBalance,
} from "api/accountApi"
import { useQuery } from "@tanstack/react-query"

export const ACCOUNT_QUERY_KEY = "accounts"

export const useAccounts = (params = {}, enabled = true) => {
  return usePaginatedResource(ACCOUNT_QUERY_KEY, getAccounts, params, enabled)
}

export const useAccount = (id, enabled = true) => {
  return useResourceItem(ACCOUNT_QUERY_KEY, getAccount, id, enabled)
}

export const useCreateAccount = () => {
  return useCreateResource(createAccount, ACCOUNT_QUERY_KEY)
}

export const useEditAccount = () => {
  return useEditResource(updateAccount, ACCOUNT_QUERY_KEY)
}

export const useDeleteAccount = () => {
  return useDeleteResource(deleteAccount, ACCOUNT_QUERY_KEY)
}

export const useAccountBalance = (id, enabled = true) => {
  return useQuery({
    queryKey: [ACCOUNT_QUERY_KEY, "balance", id],
    queryFn: () => getAccountBalance(id),
    enabled: enabled && !!id,
  })
}
